import { render } from "./GradingRules.vue?vue&type=template&id=8fb234fa&scoped=true"
import script from "./GradingRules.vue?vue&type=script&lang=js"
export * from "./GradingRules.vue?vue&type=script&lang=js"

import "./GradingRules.vue?vue&type=style&index=0&id=8fb234fa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fb234fa"]])

export default __exports__